import React from 'react';
import '../App.css'
import TypographyShowcase from './TypographyShowcase';
import HeadingsShowcase from './HeadingsShowcase';
import BackgroundsShowcase from './BackgroundsShowcase';
import InputsShowcase from './InputsShowcase';
import IconsShowcase from './IconsShowcase'; // ⬅️ додали

export default function Showcase() {
  return (
    <div style={{ padding: '50px' }}>
      <section>
        <h1>Шрифти</h1>
        <TypographyShowcase />
      </section>

      <section style={{ marginTop: 40 }}>
        <h1>Заголовки</h1>
        <HeadingsShowcase />
      </section>

      <section style={{ marginTop: 40 }}>
        <h1>Фони (Colors)</h1>
        <BackgroundsShowcase />
      </section>

      <section style={{ marginTop: 40 }}>
        <h1>Inputs</h1>
        <InputsShowcase />
      </section>

      <section style={{ marginTop: 40 }}>
        <h1>Icons</h1>
        <IconsShowcase />
      </section>
    </div>
  );
}
